import { Component } from '@angular/core';
import { Reminder } from '../../../model/reminder';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { MatDialog } from '@angular/material';
// tslint:disable-next-line:max-line-length
import { DialogCancelMedicalAppointmentComponent } from '../../dialogs/medical-appointment-cancel/dialog-medical-appointment-cancel.component';
import { MedicalAppointmentCancel } from '../../../model/medical-appointment-cancel';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
import {  DomSanitizer } from '@angular/platform-browser';
import { ReservationRescheduleWizardService } from '../../../services/wizard/reservation/reservation-reschedule.wizard.service';
import { PdfService } from '../../../services/pdf.service';

@Component({
  selector: 'app-reservation-reminder-component',
  templateUrl: './reservation-reminder.component.html',
  styleUrls: ['./reservation-reminder.component.css']
})
export class ReservationReminderComponent {

  reminders: Reminder[] = [];
  html: string;
  loading: boolean;

  constructor(public dialog: MatDialog
    , private notificationToastService: NotificationToastService 
    , private pdfService: PdfService
    , domSanitizer: DomSanitizer
    , private rrWizardService: ReservationRescheduleWizardService) {
     this.reminders = this.rrWizardService.getReminders();
    // this.reminders.forEach(item => {
    //   item.CenterLogoSafeUrl = domSanitizer.bypassSecurityTrustUrl('data:image/JPG;base64,' + item.CenterLogo);
    // });
    this.rrWizardService.getReminderHtml()
    .then((html) => this.html = html);
  }

  async reschedule() {
    await this.rrWizardService.reschedule();
  }

  async printReminder() { 
    const reminders = this.rrWizardService.getReminders();
    if (reminders != null && reminders.length > 0) {
      const report = await this.rrWizardService.getReminderReport();
      this.pdfService.base64ToPdfPrint(report.ReportBase64, 'Recordatorio');  
    }
  }

  sendMail() {
    this.notificationToastService.success('Se ha enviado el mail', 'Envio de mails');
    this.rrWizardService.sendResevationMail()
    .catch((err) =>
      this.notificationToastService.error('Error al enviar el mail '
        + JSON.stringify(err.error)
        , 'Envio de mails'));
  }

  openMedicalAppointmentCancelDialog(): void {
    const medicalAppointmentIds: number[] = [];
    this.reminders.forEach((r) => medicalAppointmentIds.push(r.MedicalAppointmentId));

    const dialogRef = this.dialog.open(DialogCancelMedicalAppointmentComponent, {
      width: '50%',
      data: { medicalAppointmentIds: medicalAppointmentIds }
    });

    dialogRef.afterClosed().subscribe((result: MedicalAppointmentCancel) => {
      if (result) {
        this.finish();
      }
    });
  }

  finish(): void {
    this.rrWizardService.finalize();
  }
}
